module.exports = __webpack_public_path__ + "static/media/on-boarding.0a6d5636.png";